module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "id": "ach3",
      "title": "Crunchy Granola Clusters"
    }
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_13",
      "title": "13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/Contents#ch3"
    }
  }, [_vm._v("Crunchy Granola Clusters")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('i', [_vm._v("Granola has long been associated with health food, despite the fact that it is often full of oil and sugar, or both! This recipe uses aquafaba and bananas to cut down on the oil and the sugar and create a naturally lighter option. Pressing down on the granola before baking helps it to stay clumped together in delectable clusters.")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 very ripe bananas")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 tablespoons aquafaba")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup peanut butter")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ cup maple syrup")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 tablespoons refined coconut oil, melted")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("2 teaspoons ground cinnamon")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("pinch ground cloves")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("3 cups old-fashioned rolled oats (not instant)")]), _vm._v(" "), _c('p', {
    staticClass: "recb"
  }, [_vm._v("1½ cups chopped walnuts")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("1.")]), _vm._v(" Preheat your oven to 350°F. Line a baking tray with either a silicone baking sheet or parchment paper. If using parchment, brush it lightly with coconut oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("2.")]), _vm._v(" In a large bowl, mash the bananas with the aquafaba, peanut butter, and maple syrup. Once this is mixed, stir in the melted coconut oil.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("3.")]), _vm._v(" Mix the remaining ingredients into the banana mixture, stirring until well combined.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('b', [_vm._v("4.")]), _vm._v(" Spread this mixture as evenly as possible onto the baking tray. Using a large, flat spatula, press down firmly on all of the unbaked granola. It should start to stick together.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('b', [_vm._v("5.")]), _vm._v(" Bake for 35 to 40 minutes, stirring every 10 minutes and rotating the tray if needed, until the granola has gotten all toasty brown. Cool before serving or storing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("YIELD:")]), _vm._v(" 5 cups"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("PREP TIME:")]), _vm._v(" 5 to 10 minutes"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("COOK TIME:")]), _vm._v(" 35 to 40 minutes")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-453fe243","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Chapter003.vue
// module id = 84
// module chunks = 0